import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import hiringRequestsAPI from 'api/hiringRequestsAPI';
import { AxiosError } from 'axios';
import { hiringRequestQueries } from 'queryKeys/hiringRequest';
import { HiringRequestScorecard } from '../../../types';

export const useQueryGetScorecardsForHiringRequest = (
  hiringRequestId: number,
  options?: Omit<UseQueryOptions<HiringRequestScorecard[], AxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<HiringRequestScorecard[], AxiosError> => {
  return useQuery({
    queryKey: hiringRequestQueries.hiringRequests.scorecards(hiringRequestId).queryKey,
    queryFn: () =>
      hiringRequestsAPI.getScorecardsForHiringRequest(hiringRequestId).then((res) => res),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};
